import SearchOffOutlined from '@mui/icons-material/SearchOffOutlined';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { NotFoundErrorProps } from './NotFoundError.props';
import { ContentWrapper } from './NotFoundError.styles';
import { Button, ButtonVariantProps } from '../../../components/atoms/Button';
import { TypographyVariantProps } from '../../../components/atoms/Typography';
import { ActionRow, BodyTypography, ErrorCard, IconCircle, TitleTypography } from '../Error.styles';

export const NotFoundError: React.FC<NotFoundErrorProps> = ({
  title = 'Page not found',
  message = "This page doesn't exist, or the link you followed may be out of date.",
}) => {
  const navigate = useNavigate();

  const onGoBack = useCallback(() => navigate(-1), [navigate]);
  const onGoHome = useCallback(() => navigate('/'), [navigate]);

  return (
    <ContentWrapper>
      <ErrorCard role="alert">
        <IconCircle severity="warning">
          <SearchOffOutlined fontSize="large" />
        </IconCircle>
        <TitleTypography variant={TypographyVariantProps.H5} fontWeight={600}>
          {title}
        </TitleTypography>
        {message && (
          <BodyTypography variant={TypographyVariantProps.Body1}>{message}</BodyTypography>
        )}
        <ActionRow>
          <Button variant={ButtonVariantProps.Primary} onClick={onGoBack}>
            Go back
          </Button>
          <Button variant={ButtonVariantProps.Secondary} onClick={onGoHome}>
            Go to Home
          </Button>
        </ActionRow>
      </ErrorCard>
    </ContentWrapper>
  );
};
